import React from 'react';
import { EcwOrder, EcwOrdersResponse, getOrderDisplay } from '../EcwConstantsTest';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface EcwOrderInfoTestProps {
    ecwOrderList: EcwOrdersResponse;
    selectedOrderInfo: EcwOrder | null | undefined;
    handleRevertOrder: (orderId: string | number) => void;
}

const EcwOrderInfoTest: React.FC<EcwOrderInfoTestProps> = ({ ecwOrderList, selectedOrderInfo, handleRevertOrder }) => {
    if (ecwOrderList && selectedOrderInfo) {
        const isSysAdmin = localStorage.getItem("roleName")?.toLowerCase() === "sysadmin";
        const logInUserfName = localStorage.getItem("firstName") ?? "";
        const logInUserlName = localStorage.getItem("lastName") ?? "";

        return (
            <div className='order-info-wrapper'>
                <div className='order-info-box'>
                    <div>
                        <span>Patient</span>
                        <p><b>{ecwOrderList?.lastName}, {ecwOrderList?.firstName}</b> {ecwOrderList?.gender} ({ecwOrderList?.birthDate})</p>
                    </div>
                    <div>
                        <span>Item</span>
                        <p><b>{selectedOrderInfo?.vaccineName || selectedOrderInfo?.medicationRequest?.medicationName || selectedOrderInfo?.medicationAdministration?.medicationName}</b></p>
                    </div>
                    <div>
                        <span>Provider</span>
                        <p>{selectedOrderInfo?.provider?.lastName} {selectedOrderInfo?.provider?.firstName} ({selectedOrderInfo?.provider?.npi})</p>
                    </div>
                    <div>
                        <span>User</span>
                        <p>{selectedOrderInfo?.loggedUser?.lastName || logInUserlName}, {selectedOrderInfo?.loggedUser?.firstName || logInUserfName}</p>
                    </div>
                    <div>
                        <span>Encounter</span>
                        <p>{selectedOrderInfo?.encounterId} ({selectedOrderInfo?.encounterDate})</p>
                    </div>
                    <div>
                        <span>Location</span>
                        <p>{selectedOrderInfo?.facility?.facilityName} {selectedOrderInfo?.orderType === "VAC" ? `(${selectedOrderInfo?.facility?.facilityId})` : ""}</p>
                    </div>
                    <div>
                        <span>Order</span>
                        <p>{getOrderDisplay(selectedOrderInfo)} ({selectedOrderInfo?.status})</p>
                    </div>
                    {selectedOrderInfo?.orderType === "VAC" ? (
                        <div>
                            <span>CVX</span>
                            <p>{selectedOrderInfo?.cvxCode}</p>
                        </div>
                    ) : selectedOrderInfo?.orderType === 'THINJ' ? (
                        <div>
                            <span>Medication Code</span>
                            <p>{selectedOrderInfo?.medicationAdministration?.medicationCode}</p>
                        </div>
                    ) : (
                        <div>
                            <span>Rx Norm</span>
                            <p>{selectedOrderInfo?.medicationRequest?.rxNormCode}</p>
                        </div>
                    )}
                </div>
                <div className="order-status-box">
                    <span>Processed</span>
                    <i className='status-square' title={selectedOrderInfo?.isSuccess === false ? (selectedOrderInfo?.ecwResponseMessage ?? '') : ''} style={{ backgroundColor: selectedOrderInfo?.colour || 'gray' }}></i>
                    {isSysAdmin && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-revert-order">Revert Order</Tooltip>}
                            delay={{ show: 250, hide: 400 }}
                        >
                            <i className="bi bi-arrow-counterclockwise revert-order-btn" onClick={() => handleRevertOrder(selectedOrderInfo.id || "")} />
                        </OverlayTrigger>
                    )}
                </div>
            </div>
        )
    }

    return null;
}

export default EcwOrderInfoTest;
